
// import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
// import CustomCarousel from './CustomCarousel';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
// import FAQSection from './FAQSection';
import FAQItem from './FAQItem';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetolavasacity() {



  const cardData =
  {
    keyword: ' Pune to Lavasa City Cabs',
    heading: 'AB Ghule Cabs: Pune to Lavasa City Cabs',
    headingDescription: 'AB Ghule Cabs offers comfortable, reliable, and affordable Pune to Lavasa City cab services. Whether you are planning a relaxing getaway, a corporate outing, or a day trip to Lavasa, our fleet of well-maintained vehicles and experienced drivers will ensure your journey is smooth and hassle-free. With competitive pricing and excellent customer service, we make sure you have a stress-free ride to this picturesque hill station. Pune is approximately 60 km from Lavasa City.',

    top: 'Top Places to Visit in Lavasa with AB Ghule Cabs',

    topPlaces: [
        {
          title: "Lavasa Lake",
          description: "Lavasa Lake is a stunning artificial lake situated in the heart of Lavasa, offering breathtaking views of the surrounding hills and the town. It's an ideal spot for a relaxing boat ride, or visitors can enjoy a peaceful walk along the beautifully designed promenade. The lake is a great place to unwind and soak in the natural beauty of the area, making it a must-visit attraction in Lavasa."
        },
        {
          title: "Dasve Viewpoint",
          description: "Dasve Viewpoint offers panoramic views of Lavasa and its surrounding hills, providing a perfect spot for photography and enjoying the serenity of nature. Whether you're hiking to the top or simply taking in the views, the viewpoint offers a fantastic opportunity to appreciate the beauty of the landscape. It's a peaceful place that showcases Lavasa's unique location amidst lush greenery."
        },
        {
          title: "Lavasa Promenade",
          description: "The Lavasa Promenade is a charming waterfront area that runs along the lake. Visitors can enjoy a leisurely walk while taking in the scenic beauty of the lakeside or relax at one of the many cafes that line the promenade. It's a perfect place for a peaceful day out, offering picturesque views, an inviting atmosphere, and plenty of places to sit and unwind."
        },
        {
          title: "Temghar Dam",
          description: "Temghar Dam, located just outside Lavasa, is a peaceful spot for nature lovers. The dam is an ideal place for a quiet picnic or a day of photography, offering views of the serene waters and surrounding hills. Its calm atmosphere makes it a perfect escape from the hustle and bustle of city life, ideal for a relaxing day in nature."
        },
        {
          title: "Sewri Fort",
          description: "Sewri Fort is an ancient fort located in the Lavasa region, providing visitors with a glimpse into the area’s historical significance. Surrounded by lush greenery, the fort offers a quiet space for exploration and reflection. Though less crowded than other attractions, it provides a unique opportunity to learn about Lavasa’s past while enjoying the peaceful atmosphere."
        },
        {
          title: "Lavasa Adventure Park",
          description: "Lavasa Adventure Park is a must-visit for thrill-seekers and adventure enthusiasts. Offering a variety of exciting activities such as zip-lining, rock climbing, and more, the park provides an adrenaline rush for individuals and families alike. Whether you're looking to challenge yourself or simply have fun, the adventure park promises an exciting day out."
        },
        {
          title: "Lavasa Hills",
          description: "Lavasa Hills offers a wonderful opportunity for trekking and hiking. The hills are known for their stunning views and natural beauty, making it a great destination for photographers and nature lovers. Whether you're an experienced trekker or just enjoy a leisurely walk, the hills offer a scenic and peaceful escape in the heart of Lavasa."
        },
        {
          title: "Lavasa International Convention Centre",
          description: "The Lavasa International Convention Centre is a state-of-the-art venue for conferences, events, and weddings. Even if you're not attending a specific event, the modern architecture and stunning views of the surrounding hills make the centre worth exploring. It’s an ideal location for business and leisure, offering top-notch facilities and a beautiful backdrop for any occasion."
        },
        {
          title: "Lakeside Promenade",
          description: "The Lakeside Promenade is a perfect place to unwind and enjoy Lavasa’s beauty. A scenic walk along the lake, with small shops and cafes, allows visitors to relax and take in the picturesque views of the water and surrounding hills. It’s an ideal spot to spend a leisurely afternoon, enjoy a meal or a drink, and simply enjoy the peaceful ambiance of Lavasa."
        },
        {
          title: "Lavasa Cuisine",
          description: "Lavasa is home to a variety of dining options, offering everything from local Maharashtrian dishes to international flavors. The restaurants and cafes in the town provide a diverse range of culinary experiences to suit every taste. Whether you're craving local delicacies or looking to try something new, Lavasa's food scene is sure to delight every visitor with its variety and quality."
        }
      ],


   services: [
    {
      "name": "Pune to Lavasa Taxi",
      description: "Travel in comfort and style with AB Ghule Cabs on your journey from Pune to Lavasa. Our taxis are well-maintained, and our professional drivers ensure you enjoy a smooth and hassle-free ride to Lavasa, a popular hill station near Pune."
    },
    {
      "name": "Pune to Lavasa Cab Services",
      description: "AB Ghule Cabs offers top-notch cab services from Pune to Lavasa. Whether you need a quick ride or a comfortable long trip, our fleet of vehicles caters to all your transportation needs, providing you with a safe and enjoyable journey."
    },
    {
      "name": "Pune to Lavasa Taxi Booking",
      description: "Booking a taxi from Pune to Lavasa is quick and easy with AB Ghule Cabs. Use our online booking platform to reserve your cab in just a few clicks. We offer a variety of vehicles, including sedans, SUVs, and luxury cars, to meet your specific needs."
    },
    {
      "name": "Taxi from Pune to Lavasa",
      description: "Planning a taxi ride from Pune to Lavasa? AB Ghule Cabs offers reliable and affordable taxi services to Lavasa, ensuring that you have a comfortable, stress-free trip. Our drivers are experienced and knowledgeable about the route, ensuring safe travel."
    },
    {
      "name": "Cab Services Pune to Lavasa",
      description: "Enjoy professional and hassle-free cab services from Pune to Lavasa with AB Ghule Cabs. We provide comfortable vehicles with skilled drivers who will ensure you arrive at your destination safely and on time. Our services cater to both local and outstation travel."
    },
    {
      "name": "Pune to Lavasa Private Car",
      description: "AB Ghule Cabs offers private car hire services for your trip to Lavasa. Whether you're traveling solo or with family, our private cars offer you the privacy, comfort, and flexibility to make the most of your journey from Pune to Lavasa."
    },
    {
      "name": "Pune to Lavasa Chauffeur Service",
      description: "For a luxury travel experience, book our chauffeur service for your Pune to Lavasa trip. AB Ghule Cabs provides experienced and professional chauffeurs who are familiar with the best routes, ensuring you have a smooth and relaxed ride."
    },
    {
      "name": "Pune to Lavasa Airport Taxi",
      description: "If you're flying into Pune Airport and need a taxi to Lavasa, AB Ghule Cabs offers efficient airport taxi services. We ensure a timely pickup from Pune Airport and a comfortable, stress-free journey to Lavasa, with experienced drivers at your service."
    },
    {
      "name": "Pune to Lavasa Taxi",
      description: "Book a reliable taxi for your trip from Pune to Lavasa with AB Ghule Cabs. Whether it's a business trip, family outing, or weekend getaway, our taxi services ensure you have a comfortable and enjoyable ride every time."
    },
    {
      "name": "Pune to Lavasa Cab",
      description: "AB Ghule Cabs provides excellent cab services from Pune to Lavasa. With a fleet of well-maintained cars and professional drivers, we ensure that your journey is pleasant, safe, and comfortable."
    },
    {
      "name": "Pune Airport to Lavasa Taxi Fare",
      description: "Traveling from Pune Airport to Lavasa? AB Ghule Cabs offers competitive taxi fares for airport transfers. Our taxi fare is inclusive of all tolls, taxes, and other charges, ensuring a transparent pricing structure for your peace of mind."
    },
    {
      "name": "Pune to Lavasa Cab Booking",
      description: "Book your ride from Pune to Lavasa with AB Ghule Cabs for a hassle-free travel experience. Our booking process is easy and secure, allowing you to choose from a variety of vehicles and travel packages that suit your needs."
    },
    {
      "name": "Pune to Lavasa Cab Fare",
      description: "Our cab fares from Pune to Lavasa are designed to be budget-friendly and transparent. The fare varies depending on the type of vehicle, travel time, and other factors, ensuring you get the best value for your money."
    },
    {
      "name": "Pune to Lavasa Cab Price",
      description: "The price for a cab from Pune to Lavasa with AB Ghule Cabs depends on your chosen vehicle type and the number of passengers. We offer competitive prices, ensuring a cost-effective and comfortable journey to Lavasa."
    },
    {
      "name": "Pune to Lavasa Taxi Fare",
      description: "The taxi fare for a journey from Pune to Lavasa with AB Ghule Cabs is affordable and all-inclusive. Our pricing includes all taxes, tolls, and surcharges, so you know exactly what you're paying for."
    },
    {
      "name": "Pune to Lavasa Innova Taxi",
      description: "Travel in comfort with an Innova taxi for your Pune to Lavasa trip. AB Ghule Cabs offers well-maintained Toyota Innova taxis, ideal for families or groups of friends who want to enjoy a spacious and comfortable ride."
    },
    {
      "name": "Pune to Lavasa Tempo Traveller on Rent",
      description: "For larger groups, AB Ghule Cabs offers tempo traveller rentals for the Pune to Lavasa journey. Our tempo travellers can accommodate up to 12-15 passengers, ensuring everyone travels together comfortably and safely."
    },
    {
      "name": "Pune to Lavasa Innova Crysta on Rent",
      description: "AB Ghule Cabs provides Toyota Innova Crysta rentals for your Pune to Lavasa trip. The Innova Crysta offers a premium experience with extra comfort, making it an excellent choice for families or groups looking for a luxurious journey."
    },
    {
      "name": "Pune to Lavasa Cab Package",
      description: "AB Ghule Cabs offers customizable cab packages for your Pune to Lavasa trip. Whether you need a one-way journey, round trip, or multiple-day tour, our cab packages are designed to suit your needs and budget. Enjoy a flexible and stress-free travel experience."
    },
    {
      "name": "Pune to Lavasa City Cabs Contact Number",
      description: "Contact AB Ghule Cabs at +91 8624029699 for prompt and efficient Pune to Lavasa city cabs. We ensure a smooth and enjoyable ride for all our customers."
    }
  ],

  tableData: [
    ["Pune to Lavasa Taxi", "-Pune to Lavasa Cab Services"],
    ["Pune to Lavasa Taxi Booking", "-Taxi from Pune to Lavasa"],
    ["Cab services Pune to Lavasa", "-Pune to Lavasa Private Car"],
    ["Pune to Lavasa chauffeur Service", "-Pune to Lavasa Airport Taxi"],
    ["Pune to Lavasa Taxi", "-Pune to Lavasa Cab"],
    ["Pune Airport to Lavasa Taxi Fare", "-Pune to Lavasa cab booking"],
    ["Pune to Lavasa Cab fare", "-Pune to Lavasa Cab Price"],
    ["Pune to Lavasa Taxi fare", "-Pune to Lavasa Innova taxi"],
    ["Pune to Lavasa tempo traveller on rent", "-Pune to Lavasa Innova Crysta on Rent"],
    ["Pune to Lavasa cab package", ""]
  ],
  
  whychoose: [
    {
      WhyChooseheading: "Reliable and Timely Service",
      WhyChoosedescription: "At AB Ghule Cabs, we understand that timely travel is essential, especially when heading to a beautiful destination like Lavasa. Our drivers are always on time, ensuring that your journey from Pune to Lavasa is seamless and stress-free."
    },
    {
      WhyChooseheading: "Comfortable and Scenic Ride",
      WhyChoosedescription: "Experience a comfortable and scenic ride as you travel from Pune to Lavasa. Our fleet of well-maintained vehicles is equipped with air-conditioning, ample legroom, and all the necessary amenities to make your trip enjoyable."
    },
    {
      WhyChooseheading: "Experienced and Professional Drivers",
      WhyChoosedescription: "Our drivers are experienced, professional, and familiar with the Pune to Lavasa route. They will ensure a safe and smooth journey, guiding you through the winding roads and scenic landscapes of the Western Ghats."
    },
    {
      WhyChooseheading: "Affordable Pricing",
      WhyChoosedescription: "We offer competitive pricing with transparent fare structures. Whether you're traveling solo or in a group, we ensure that you get the best value for your money, with no hidden charges."
    },
    {
      WhyChooseheading: "Well-Maintained Fleet",
      WhyChoosedescription: "Our vehicles are regularly serviced and inspected, ensuring they are in top condition for your journey. We provide a range of vehicle options to suit different preferences and group sizes, ensuring comfort throughout the trip."
    },
    {
      WhyChooseheading: "24/7 Availability",
      WhyChoosedescription: "Our services are available round-the-clock, so you can book a cab to Lavasa at any time. Whether you're planning an early morning trip or a late-night departure, AB Ghule Cabs is here to serve you."
    },
    {
      WhyChooseheading: "Hassle-Free Booking",
      WhyChoosedescription: "Booking a cab to Lavasa with AB Ghule Cabs is simple and quick. You can book online through our website or app, or you can call our customer service team for assistance."
    },
    {
      WhyChooseheading: "Scenic Route Experience",
      WhyChoosedescription: "The journey to Lavasa is known for its scenic beauty, and we ensure that your trip is as enjoyable as the destination. With AB Ghule Cabs, you can sit back, relax, and take in the breathtaking views along the way."
    }
  ]
  
  
  

  }

  const faqData = [
    {
      id: 'FAQ1',
      question: 'How can I book a cab from Pune to Lavasa with AB Ghule Cabs?',
      answer: 'You can book a cab easily through our website, mobile app, or by calling our customer service team. We provide multiple booking options for your convenience.',
    },
    {
      id: 'FAQ2',
      question: 'What types of vehicles are available for booking from Pune to Lavasa?',
      answer: 'We offer a range of vehicles, including sedans, SUVs, and luxury cars, to accommodate your needs, whether you\'re traveling alone, with family, or in a group.',
    },
    {
      id: 'FAQ3',
      question: 'Are the drivers experienced for the Pune to Lavasa route?',
      answer: 'Yes, all our drivers are experienced and familiar with the Pune to Lavasa route. They will ensure a smooth, safe, and comfortable journey.',
    },
    {
      id: 'FAQ4',
      question: 'How do I pay for my ride from Pune to Lavasa?',
      answer: 'We offer multiple payment options, including cash, credit/debit cards, and online payments through our mobile app, giving you flexibility and convenience.',
    },
    {
      id: 'FAQ5',
      question: 'Are there any additional charges for waiting or detours?',
      answer: 'Additional charges may apply for waiting time or detours. However, we maintain transparency in pricing, and any extra charges will be communicated to you beforehand.',
    },
    {
      id: 'FAQ6',
      question: 'How long does it take to travel from Pune to Lavasa?',
      answer: 'The journey from Pune to Lavasa typically takes around 1.5 to 2 hours, depending on traffic conditions and your departure time.',
    },
    {
      id: 'FAQ7',
      question: 'Can I book a round trip from Pune to Lavasa?',
      answer: 'Yes, you can easily book a round trip for your journey to Lavasa. Simply provide your return details when making your booking, and we will take care of the rest.',
    },
    {
      id: 'FAQ8',
      question: 'Do you offer group bookings for Pune to Lavasa trips?',
      answer: 'Yes, we offer group bookings for trips from Pune to Lavasa. Whether it\'s for a family outing or a corporate retreat, we can accommodate large groups and ensure a comfortable journey for everyone.',
    },
    {
      id: 'FAQ9',
      question: 'Is there a luggage allowance for my trip to Lavasa?',
      answer: 'Our vehicles have ample space for standard luggage. If you have special luggage needs or additional items, please let us know during booking, and we\'ll make necessary arrangements.',
    },
    {
      id: 'FAQ10',
      question: 'What makes AB Ghule Cabs the best choice for a Pune to Lavasa trip?',
      answer: 'AB Ghule Cabs offers reliable, safe, and affordable travel, with experienced drivers, well-maintained vehicles, and hassle-free booking. We ensure that your journey from Pune to Lavasa is comfortable and enjoyable.',
    },
  ];
  
  const testimonials = [
    {
      id: 1,
      name: 'Mr. Amit Joshi',
      feedback: 'Our trip to Lavasa was made so much easier with AB Ghule Cabs. The driver was punctual, the vehicle was comfortable, and we had a smooth ride throughout the journey. It was a relaxing trip, and we couldn’t have asked for a better experience. I highly recommend AB Ghule Cabs for your next visit to Lavasa!',
      rating: 5,
    },
    {
      id: 2,
      name: 'Ms. Neha Sharma',
      feedback: 'I booked a cab from Pune to Lavasa with AB Ghule Cabs for a weekend getaway, and it was a great decision. The ride was pleasant, the car was clean and well-maintained, and the driver knew the best routes. We had a stress-free trip and reached Lavasa on time. I’ll definitely use AB Ghule Cabs again for future trips!',
      rating: 5,
    },
  ];
  
  






  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 8624029699",
      

    ],
    email: "booking@abghulecabs.com"
  };


  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Mumbai Cab Service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Mumbai to Shirdi Cab",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Mumbai Darshan Cabs",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Mumbai to Vadodara Taxi",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Mumbai to Pune Cab",
    },
    {
      place: "/images/keyword/6.jpg",
      text: " Mumbai to Goa Taxi",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Mumbai Airport Cab",
    },

    {
      place: "/images/keyword/8.jpg",
      text: "Mumbai Surat Cabs",
    },

    {
      place: "/images/keyword/9.jpg",
      text: "Mumbai to Mahabaleshwar Cab",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Mumbai to Konkan Cab",
    },

    {
      place: "/images/keyword/11.jpg",
      text: "Pune Cab Service",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune Taxi Hire",
    },

    {
      place: "/images/keyword/13.jpg",
      text: "Pune Online Cab Booking",
    },

    {
      place: "/images/keyword/14.jpg",
      text: "Best Cab Service in Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Pune to Mumbai Cabs",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Nashik Cabs",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Mahabaleshwar Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Lonavala Cabs",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Shirdi Cab",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Lavasa city cabs",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Bhimashankar Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Indore Cabs",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Konkan Darshan Cabs",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune Outstation Cabs",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Panchgani Cab Fare",
    },
    {
      place: "/images/keyword/26.jpg",
      text: "Pune to Mumbai International Airport Cab",
    },
    {
      place: "/images/keyword/27.jpg",
      text: "Ashtavinayak Darshan Cab",
    },
  ];


  const images = [
    { src: "/images/our-fleet/1.jpg", alt: "Image 1" },
    { src: "/images/our-fleet/2.jpg", alt: "Image 2" },
    { src: "/images/our-fleet/3.jpg", alt: "Image 3" },
    { src: "/images/our-fleet/4.jpg", alt: "Image 4" },
    { src: "/images/our-fleet/5.jpg", alt: "Image 5" },
    { src: "/images/our-fleet/6.jpg", alt: "Image 6" },
    { src: "/images/our-fleet/7.jpg", alt: "Image 7" },
    { src: "/images/our-fleet/8.jpg", alt: "Image 8" },
    { src: "/images/our-fleet/9.jpg", alt: "Image 9" },
  ];





  return (
    <div>
      <Helmet>
  <title>Contact: +91 8624029699 | AB Ghule Cabs | Pune to Lavasa City Cabs | Affordable & Reliable</title>
  <meta name="description" content="Book Pune to Lavasa city cabs with AB Ghule Cabs. Affordable and reliable taxi services for one-way, round trips, and airport drop. Call +91 8624029699." />
  <meta name="keywords" content="Pune to Lavasa Taxi, Pune to Lavasa Cab Services, Pune to Lavasa Taxi Booking, Taxi from Pune to Lavasa, Cab services Pune to Lavasa, Pune to Lavasa Private Car, Pune to Lavasa chauffeur Service, Pune to Lavasa Airport Taxi, Pune to Lavasa Taxi, Pune to Lavasa Cab, Pune Airport to Lavasa Taxi Fare, Pune to Lavasa cab booking, Pune to Lavasa Cab fare, Pune to Lavasa Cab Price, Pune to Lavasa Taxi fare, Pune to Lavasa Innova taxi, Pune to Lavasa tempo traveller on rent, Pune to Lavasa Innova Crysta on Rent, Pune to Lavasa cab package" />
  <meta name="robots" content="index, follow" />
  <meta property="og:title" content="Contact: +91 8624029699 | AB Ghule Cabs | Pune to Lavasa City Cabs | Affordable & Reliable" />
  <meta property="og:description" content="Book Pune to Lavasa city cabs with AB Ghule Cabs. Affordable and reliable taxi services for one-way, round trips, and airport drop. Call +91 8624029699." />
  <meta property="og:image" content="https://abghulecabs.com/images/pune-to-lavasa-cabs.jpg" />
  <meta property="og:url" content="https://abghulecabs.com/pune-to-lavasa-cab" />
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="AB Ghule Cabs" />

  {/* JSON-LD Structured Data for Schema Markup */}
  <script type="application/ld+json">
    {`
      {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": "AB Ghule Cabs - Pune to Lavasa City Cabs",
        description: "Book Pune to Lavasa city cabs with AB Ghule Cabs. Affordable and reliable taxi services for one-way, round trips, and airport drop. Call +91 8624029699.",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Pune, Maharashtra",
          "addressLocality": "Pune",
          "addressRegion": "Maharashtra",
          "postalCode": "411001",
          "addressCountry": "IN"
        },
        "telephone": "+91-8624029699",
        "url": "https://abghulecabs.com/pune-to-lavasa-cab",
        "logo": "https://abghulecabs.com/images/pune-to-lavasa-cabs.jpg",
        "image": "https://abghulecabs.com/images/pune-to-lavasa-cabs.jpg",
        "priceRange": "₹2500 - ₹5500",
        "offers": {
          "@type": "Offer",
          "url": "https://abghulecabs.com/pune-to-lavasa-cab",
          "priceCurrency": "INR",
          "price": "2500",
          "priceValidUntil": "2024-12-31"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.7",
          "reviewCount": "950"
        },
        "review": [
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Suresh Jadhav"
            },
            "datePublished": "2024-12-15",
            "reviewBody": "Amazing service! The cab was comfortable, and the driver was very professional. A smooth ride to Lavasa."
          },
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Ritu Sharma"
            },
            "datePublished": "2024-12-12",
            "reviewBody": "Affordable and prompt service. Highly recommend for anyone looking to travel from Pune to Lavasa."
          }
        ],
        "serviceArea": {
          "@type": "Place",
          "name": "Pune and Lavasa",
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "18.3504",
            "longitude": "73.7534"
          }
        },
        "availableChannel": {
          "@type": "ServiceChannel",
          "serviceUrl": "https://abghulecabs.com/pune-to-lavasa-cab"
        },
        "keywords": "Pune to Lavasa Taxi, Pune to Lavasa Cab Services, Pune to Lavasa Taxi Booking, Taxi from Pune to Lavasa, Cab services Pune to Lavasa, Pune to Lavasa Private Car, Pune to Lavasa chauffeur Service, Pune to Lavasa Airport Taxi, Pune to Lavasa Taxi, Pune to Lavasa Cab, Pune Airport to Lavasa Taxi Fare, Pune to Lavasa cab booking, Pune to Lavasa Cab fare, Pune to Lavasa Cab Price, Pune to Lavasa Taxi fare, Pune to Lavasa Innova taxi, Pune to Lavasa tempo traveller on rent, Pune to Lavasa Innova Crysta on Rent, Pune to Lavasa cab package"
      }
    `}
  </script>
</Helmet>

      <section id="about" className="jarallax text-light">
        <div className="center-y relative text-center">
          <div className="container">
            <div className="row">
              <div className="col-md-12 text-center">
                <h1 className='text-white'>{cardData.keyword}</h1>
              </div>
              <div className="clearfix"></div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/20.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#FF4101', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px',
                        transition: 'transform 0.2s'
                      }}

                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Ab Ghule Cabs</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        {faqData.map((faq) => (
                          <FAQItem key={faq.id} id={faq.id} question={faq.question} answer={faq.answer} />
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <div>

                <div className="contact-box Borderr">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details">
                    <p><strong className='darkcolor'>Mobile No:</strong></p>
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4' >
              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })}


              <div className="gallery-container">
                <h2 className="gallery-title">Our Fleets</h2>
                <div className="gallery-row d-flex flex-wrap">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}
                  {/* <Link to='/gallery' className=' border radius-5 bg-redd p-3 text-white rounded-5 '>
                    See Gallery
                  </Link> */}
                </div>
              </div>

              <div className=" rounded p-4 shadow-sm Uni_border "
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #FF4101',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#FF4101' }}>
                      <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 8624029699" className="d-block  text-white">+91 8624029699</a>
                        

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                        <a href="mailto:booking@abghulecabs.com" className=" text-white d-block">
                          booking@abghulecabs.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                        <p className="whit text-white ">
                          <i> AB Ghule Cabs<br />
                            R -10 Office No -1606,   <br />
                            Life Republic Mulshi, Marunji  <br />
                            Pune, Maharashtra - 411057.

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>



            </div>
          </div>
        </div>
      </section>






    </div>
  );
}

export default Punetolavasacity;